import { Draft } from '@weblite/ts-action/draft'
import { createStorage } from '../lib/storage'

export const [draftsStorage, draftsReducer] = createStorage<Draft>('drafts')
